import React from 'react';
import './multierratas.styles.css';
import IntlMessage from '../../../helpers/intlMessage';

const MultiErratasPage = (props) => {
  return (
    <React.Fragment>
      {props.listagemErratas && props.listagemErratas.length > 0 ? (
        <div className='mv-multierratas-container'>
          <div className='responsive'>
            <table id='erratas-table' className='table table-hover'>
              <thead>
                <tr className='thead'>
                    <th>ID</th>
                    <th><IntlMessage id = "general.requestsPanel.date"/></th>
                    <th><IntlMessage id = "general.requestsPanel.performer"/></th>
                    <th><IntlMessage id = "dashboards.examDetail.crm"/></th>
                </tr>
              </thead>
              <tbody style={{ cursor: 'pointer' }}>
                {props.listagemErratas.map((errata) => (
                  <tr key={errata.id_laudo_texto}>
                    <td>{errata.id_laudo_texto}</td>
                    <td>{new Date(errata.datacad).toLocaleDateString()}</td>
                    <td>{errata.nm_executante}</td>
                    <td>{errata.crm_executante}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className='table-loader-container'>
          <div className='table-loader'></div>
        </div>
      )}
    </React.Fragment>
  );
};

export default MultiErratasPage;



// WEBPACK FOOTER //
// ./src/app/common/multierratas/multierratas.page.js